import React, { useEffect, useState,useRef } from 'react'
import styled  from 'styled-components'
import { toast } from 'react-toastify';
import dayjs from 'dayjs'
import qs from 'qs'
import { InfoCircleOutlined ,LoadingOutlined} from '@ant-design/icons'
import { Tooltip,Spin } from 'antd';
import { useNavigate,useLocation,Link} from 'react-router-dom'
import CountDown from '../../components/CountDown';
import { gotUserInfo,sendingCode,bindEmailApi } from '../../apis';
import {
    EmailShareButton,
    EmailIcon,
    TwitterShareButton,
    XIcon,
    TelegramShareButton,
    TelegramIcon,
    FacebookShareButton,
    FacebookIcon,
    LineShareButton,
    LineIcon,
    WhatsappShareButton,
    WhatsappIcon,
} from "react-share";

export default function Account() {
  const navigate = useNavigate()
  const {search} = useLocation()
  const FormRef =  useRef(null)
  const text = '把您的【My Node ID】分享给好友，您和好友都可以获得BFT奖励'
  const FrezText = '被锁定的BFT将在一个小时以后解锁'
  const [spinning, setSpinning] = useState(false);
  const [isSend, setIsSend] = useState(0)
  const [startTimer, setStartTimer] = useState(0)
  const [shareUrl, setShareUrl] = useState("")
  const shareTitle = "Welcome to Borderfree!"
  let params = qs.parse(search.slice(1))
  
  let [bindSwitch,setBindSwitch] = useState(false)
  const [userInfo,setUserInfo] = useState({})
  
  const copyFN = () => {
    let nodeId = userInfo.nodeId || ''
    if(nodeId === '') {
        toast.error('复制失败');
        return false
    }
    var aux = document.createElement("input"); 
    aux.setAttribute("value", nodeId); 
    document.body.appendChild(aux); 
    aux.select();
    document.execCommand("copy"); 
    document.body.removeChild(aux);
    toast.success('已复制到剪贴板')
  }

  const getCode =(e)=>{
    
    const loginForm = document.getElementById('login-form')
    const formData = new FormData(loginForm);
    const email = formData.get('email');
    if(email === ''){
        toast.warn('输入邮箱不能为空！')
        return false
    }
    sendCode(email)
    .then(res => {
      if(res.code === 0 ){
          setSpinning(false)
          toast.success('The verification code has been sent !')
          setStartTimer(startTimer => startTimer + 1)
      }else{
        setSpinning(false)
      }
    })
    .catch((err) => {
      toast.error(err)
      setSpinning(false)
    })
   }
   const bindEmailFn = async () => {

    const formData = new FormData(FormRef.current);
    const email = formData.get('email');
    const code = formData.get('code');
    if(email === ''){
        toast.warn('输入邮箱不能为空！')
        return false
    }else if(code === ''){
        toast.warn('输入验证码不能为空！')
        return false
    }else {
        let res = await bindEmail({email,code})
        if(res.code === 0 ){
            setSpinning(false)
            toast.success('Binding the mailbox successfully！')
            navigate(-1)
        }else{
            toast.error(res.message)
            setSpinning(false)
        }
    }
   
   }
   const bindEmail = async (data) => {
    setSpinning(true)
    let res = await bindEmailApi(data)
    // console.log('123123',res.data)
    if(res.data.code === 0){
        setStartTimer(0)
        setBindSwitch(false)
    }
    return res.data
   }

   async function sendCode(email) {
    setSpinning(true)
    let res = await sendingCode({email})
    // console.log(res.data)
    return res.data
   }

  useEffect(()=>{
    async function getUserInfo(){

        let res = await gotUserInfo()
        // console.log(res.data)
        if(res.data.code === 0){
          setUserInfo(res.data.data)
          setShareUrl(`https://borderfree.app/invitation?inviterId=${res.data.data.nodeId}`)
        }
    }
    if(params?.token){
        localStorage.setItem('token',params?.token)
        getUserInfo()
    }  
    // console.log(params?.token)
  },[params?.token,bindSwitch])

  function isAbnormal() {
    if (userInfo?.userStatus === undefined) {
        return false
    }
    if (userInfo?.userStatus !== 0) {
        return true
    }
    return false
  }

  return (
   
    <Block className='w-[1100px] text-left mx-auto sm:w-full sm:px-[15px] md:w-full md:px-[15px]'>
        <Title className='w-[128px] h-[40px] text-[32px] my-[40px] sm:text-[20px] md:text-[20px] sm:mt-[15px] md:mt-[15px] sm:mb-[5px] md:mb-[5px]'>会员中心</Title>
        <Warpper className='p-8  sm:p-4 md:p-4'>
                <NodeId>
                    <span className='sm:text-sm md:text-sm'>My Node ID：</span>
                    <p>{userInfo?.nodeId ? userInfo?.nodeId.replace(userInfo?.nodeId.substring(5,userInfo?.nodeId.length-4),"****"):''}</p>
                    <div  id="my-copy-btn" style={{marginLeft:'5px',cursor:'pointer'}} onClick={()=>{
                        copyFN()
                    }}>
                        <svg t="1698068248542" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19321" width="16" height="16">
                        <path d="M597.333333 341.333333H170.666667c-47.061333 0-85.333333 38.272-85.333334 85.333334v426.666666c0 47.061333 38.272 85.333333 85.333334 85.333334h426.666666c47.061333 0 85.333333-38.272 85.333334-85.333334V426.666667c0-47.061333-38.272-85.333333-85.333334-85.333334z" p-id="19322" fill="#1C58FD"></path>
                        <path d="M853.333333 85.333333H426.666667a85.333333 85.333333 0 0 0-85.333334 85.333334v85.333333h341.333334a85.333333 85.333333 0 0 1 85.333333 85.333333v341.333334h85.333333a85.333333 85.333333 0 0 0 85.333334-85.333334V170.666667a85.333333 85.333333 0 0 0-85.333334-85.333334z" p-id="19323" fill="#1C58FD"></path>
                        </svg>
                    </div>
                    <Tooltip className='ml-2' placement="right" title={text}>
                        <InfoCircleOutlined color='#1C58FD' />
                    </Tooltip>
                </NodeId>
                <Vip className='w-full my-[32px]'>
                    <div>
                        <div className=' flex sm:text-sm'>
                            <label >会员级别：</label>
                            <div>
                                <p>{userInfo?.isVip ? `VIP${userInfo?.vipLevel}`:'Free'}</p>
                            {(!userInfo?.isVip || !userInfo.vipDays > 0) ? <Tips>限速中,提速需升级。</Tips>:'' } 
                            </div>
                        </div>
                        <div  className='flex sm:text-sm'>
                            <label>会员到期：</label><span>{userInfo?.vipExpireDate ? dayjs(new Date(userInfo.vipExpireDate)).format("YYYY-MM-DD"):'-'}</span>
                        </div>
                    </div>
                    <Link to={`/vip?token=${params?.token}`}    target="_blank" rel="noopener noreferrer" style={{marginTop:'9px'}}>
                        <Button className='w-[120px] h-[34px] sm:w-[80px] sm:h-[28px] sm:text-sm lg:text-sm lg:h-[28px]'>会员升级</Button>
                    </Link>
                    {/* 49.212.213.214:8004 */}
                </Vip>
                <Time>
                    <div  className=' flex sm:text-sm' >
                     <label>特邀码</label>
                    </div>
                    <Button className='w-[120px] h-[34px] sm:w-[80px] sm:h-[28px] sm:text-sm lg:text-sm lg:h-[28px]' onClick={()=>{
                    navigate('/secret',{
                        state:{
                            token: params?.token 
                        }
                    })
                    }}>卡密激活</Button>
                </Time>
        </Warpper>
        <Warpper className='p-8 sm:p-4'>
            <BFT>
                <div className=''>
                    <div  className='flex items-center'>
                        <span className='text-base sm:text-sm'>待领取的BFT：</span>
                        <Text className='text-[24px] sm:text-[20px]'>{userInfo?.points}</Text>
                    </div>
                    <div  className='flex items-center'>
                        <span className='text-sm sm:text-sm'>被锁定BFT：</span>
                        <Text className='text-[16px] sm:text-[18px]'>{userInfo?.frozen_points}</Text>
                        <Tooltip className='ml-2' placement="right" title={FrezText}>
                            <InfoCircleOutlined color='#1C58FD' />
                        </Tooltip>
                    </div>
                    <div  className='flex items-center'>
                        <span className='text-sm sm:text-sm'>挖矿奖励：</span>
                        <Text className='text-[16px] sm:text-[18px]'>{userInfo?.mint_points}</Text>
                    </div>
                    <div  className='flex items-center'>
                        <span className='text-sm sm:text-sm'>邀请奖励：</span>
                        <Text className='text-[16px] sm:text-[18px]'>{userInfo?.invite_points}</Text>
                    </div>
                    {
                        isAbnormal() ?
                        <div className='flex items-center'>
                            <span className='text-sm sm:text-sm' style={{color:'#FF4D4F'}}>账户异常，请联系客服。</span>
                        </div>
                        :
                        ''
                    }
                </div>
                {
                    isAbnormal() ?   
                    <Button style={{background:'#F5F5F5',borderColor:'#F5F5F5',color:'#999999'}} disabled className='w-[120px] h-[34px] sm:w-[80px] sm:h-[28px] sm:text-sm lg:text-sm lg:h-[28px]'>领取</Button>
                    :
                    <Button className='w-[120px] h-[34px] sm:w-[80px] sm:h-[28px] sm:text-sm' style={{marginTop:0}} onClick={()=>{
                    window.open("https://claim.borderfree.app/",'_blank')
                    }}>领取</Button>
                }
                {/* <Button className='w-[120px] h-[34px] sm:w-[80px] sm:h-[28px] sm:text-sm' style={{marginTop:0}} onClick={()=>{
                  window.open("http://49.212.183.214:8003/",'_blank')
                }}>领取</Button> */}
                {/* <Button className='w-[120px] h-[34px] sm:w-[80px] sm:h-[28px] sm:text-sm' style={{marginTop:0}} onClick={()=>{
                  window.open("http://49.212.213.144:8003/",'_blank')
                }}>领取</Button> */}
            </BFT>
        </Warpper>
        <Warpper className='p-8 sm:p-4'>
        <Spin
            spinning={spinning}
            indicator={
            <LoadingOutlined
                style={{
                fontSize: 24,
                }}
                percent="auto"
                fullscreen="true"
            />
         }>
            <div className='flex justify-between items-center'>
                <div className='sm:text-sm'>
                    <Email className='text-base sm:text-sm'>邮箱：{userInfo?.email?userInfo.email:<span className='text-sm text-[#8E8E8E]'>暂未绑定</span>}</Email>
                    <EmailTips>绑定邮箱可获取更多官方动向和优惠信息。</EmailTips>
                </div>
                <div>
                    {
                        userInfo?.email ?
                        <EmailStatus>已绑定</EmailStatus>
                        :
                        <Button className='w-[120px] h-[34px] sm:w-[80px] sm:h-[28px] sm:text-sm' style={{marginTop:0}} onClick={()=>{
                            setBindSwitch(true)
                        }}>邮箱绑定</Button>
                    }
                </div>
            </div>
            {
                bindSwitch 
                &&
                <div className='mt-4'>
                    <form id="login-form" className='w-full' ref={FormRef}>
                            <div className="form-item flex items-center">
                                <label htmlFor="email" className='w-[60px] sm:w-[50px] text-left mr-2 sm:text-sm'>邮箱:</label>
                                <Input className=' w-[300px] sm:w-[255px]'>
                                    <input 
                                    type="text" 
                                    className="w-full h-[34px] sm:w-full border-none" 
                                    id="Email" 
                                    name="email" 
                                    placeholder="请输入邮箱地址"  /> 
                                </Input>
                            </div>
                        
                            <div className="form-item flex items-center mt-4">
                                <label htmlFor="code" className='w-[60px] sm:w-[50px] mr-2 text-left sm:text-sm'>验证码:</label>
                                <Input className='w-[300px] sm:w-[255px]'>
                                    <input 
                                    type="text" 
                                    className="flex-1 h-[34px] sm:w-full border-none" 
                                    id="code" 
                                    name="code"  
                                    placeholder="请输入验证码" />
                                    <CountDown style={{
                                            width: 90,
                                            height: 26,
                                            lineHeight: '26px',
                                            position: 'relative',
                                            top: 1,
                                            right: 1,
                                            fontSize: 12,
                                            color: '#FFFFFF',
                                            backgroundColor: isSend === 1 ? "#B3B3B3" : "#0057FF",
                                            borderRadius: 5,
                                            textAlign: 'center',
                                            cursor: "pointer"
                                        }} 
                                        onClick={getCode} 
                                        callback={(sendNum) => {
                                            setIsSend(sendNum)
                                        }} 
                                        status={startTimer}/>
                                </Input>
                            </div>
                            <div  className='ml-[67px]' style={{marginTop:'15px'}}>
                                <button 
                                type="button" 
                                className="w-[180px] sm:w-[120px] h-[34px] text-[#1C58FD] rounded-[4px] border border-[#1C58FD]" 
                                id="login-btn"
                                onClick={()=>{
                                    bindEmailFn()
                                }}>确定</button>
                            </div>
                    </form>
                </div>
            }
        </Spin>
        </Warpper>
        <Warpper className='p-8 sm:p-4'>
            <BFT>
                <div  className='flex items-center'>
                    <span className='text-base sm:text-sm'>申请代理商</span>
                    {/* <Text className='text-[24px] sm:text-[20px]'>{userInfo?.points}</Text> */}
                </div>
                <Button className='w-[120px] h-[34px] sm:w-[80px] sm:h-[28px] sm:text-sm' style={{marginTop:0}} onClick={()=>{
                  window.open("https://borderfree.app/contact-us-2/",'_blank')
                }}>去申请</Button>
            </BFT>
        </Warpper>
        <Warpper className='p-8 sm:p-4'>
            <BFT>
            <div  className='flex flex-col'>
                <div className='flex items-center sm:flex-col sm:items-start'>
                    <span className='text-base sm:text-sm'>邀请好友安装 获得BFT奖励</span>
                </div>
            </div>
            <div className='flex items-center'>
            <EmailShareButton 
                className="ml-1" 
                url={shareUrl}
                title={shareTitle}>
                <EmailIcon size={32} round />
            </EmailShareButton>
            <TwitterShareButton 
                className="ml-1" 
                url={shareUrl}
                title={shareTitle}>
                <XIcon size={32} round />
            </TwitterShareButton>
            <TelegramShareButton 
                className="ml-1" 
                url={shareUrl}
                title={shareTitle}>
                <TelegramIcon size={32} round />
            </TelegramShareButton>
            <FacebookShareButton 
                className="ml-1" 
                url={shareUrl}
                title={shareTitle}>
                <FacebookIcon size={32} round />
            </FacebookShareButton>
            <LineShareButton 
                className="ml-1" 
                url={shareUrl}
                title={shareTitle}>
                <LineIcon size={32} round />
            </LineShareButton>
            <WhatsappShareButton 
                className="ml-1 mr-1" 
                url={shareUrl}
                title={shareTitle}>
                <WhatsappIcon size={32} round />
            </WhatsappShareButton>
            <Button className='w-[120px] h-[34px] sm:w-[80px] sm:h-[28px] sm:text-sm lg:text-sm lg:h-[28px]' onClick={()=>{
                navigator.clipboard.writeText(shareUrl).then(function() {
                    toast.success('已复制到剪贴板')
                }
                , function() {
                    toast.error('复制失败')
                })
            }}>Copy Link</Button>  
            </div>
            </BFT>
        </Warpper>
        <Warpper className='p-8 sm:p-4'>
            <BFT>
                <div  className='flex flex-col'>
                    <div className='flex items-center sm:flex-col sm:items-start'>
                        <span className='text-base sm:text-sm'>邀请您的好友的Node ID：</span>
                        <span>{userInfo?.inviter_node_id ? userInfo?.inviter_node_id.replace(userInfo?.inviter_node_id.substring(5,userInfo?.inviter_node_id.length-4),"****"):'暂无'}</span>
                    </div>
                    <div className='flex items-center'>
                        <span className='text-sm sm:text-xs'>您已邀请的人数：</span>
                        <Text className='text-[16px] sm:text-[18px]'>{userInfo?.invite_count}</Text>
                    </div>
                </div>
                {
                   !!userInfo?.inviter_node_id  ?
                    <Button style={{background:'#F5F5F5',borderColor:'#F5F5F5',color:'#999999'}} disabled className='w-[120px] h-[34px] sm:w-[80px] sm:h-[28px] sm:text-sm lg:text-sm lg:h-[28px]'>已绑定</Button>
                    :
                    <Button className='w-[120px] h-[34px] sm:w-[80px] sm:h-[28px] sm:text-sm lg:text-sm lg:h-[28px]' onClick={()=>{
                        navigate('/invite',{
                            state:{
                                token: params?.token 
                            }
                        })
                    }}>去填写</Button>  
                }
            </BFT>
        </Warpper>
    </Block>
  )
}
const Block = styled.div`
    max-width:1100px;
    

`
const NodeId  = styled.div`
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #1A1A1A;

`
const Warpper = styled.div`
    width: 100%;
    background: #FFFFFF;
    border-radius: 16px;
    margin: 0 auto;
    margin-bottom:24px;
`

const Title = styled.h4`
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1A1A1A;
    text-align: left;
`
const Vip = styled.div`
    
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1A1A1A;
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
    > label {
        width: 109px;
        text-align:right;
        display:block
    }
`
const Time = styled.div`
   
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #1A1A1A;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > label {
        width: 109px;
        text-align:right;
        display:block
    }
    
`
const  Email = styled.div`
    height: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1A1A1A;
    line-height: 22px;
`
const  EmailTips = styled.div`
    height: 16px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #B3B3B3;
    line-height: 16px;
    margin-top:6px;
 `
const  EmailStatus = styled.span`
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #1C58FD;
    line-height: 20px;

`


const  Button = styled.button`
   
    background:#fff;
    height: 34px;
    border-radius: 4px;
    border: 1px solid #1C58FD;
    color:#1C58FD;
    font-size:14px;
`
const BFT = styled.div`
    /* height: 24px; */
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1A1A1A;
    line-height: 24px;
    display:flex;
    align-items:center;
    justify-content: space-between;
    
`
const Text = styled.p`
    height: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1C58FD;
    line-height: 28px;
    margin:0;
`

const RightBlock = styled.div`
    display:flex;
    flex-direction:column;
    justify-content: flex-end;
    align-items:flex-end;
`
const Tips = styled.p`
    height: 16px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FF4D4F;
    line-height: 16px;
`


const Input = styled.div`
    height: 34px;
    background: #F2F2F2;
    border-radius: 4px;
    padding: 6px 6px 6px 10px;
    display: flex;
    align-items: center;
    overflow: hidden;
    >input {
        flex: 1;
        display:block;
        background: #F2F2F2;
        height: 100%;
    }
    >input:focus {
    color: var(--bs-body-color);
    background-color: var(--bs-body-bg);
    outline: none;
    box-shadow: none;
  }
`

const CodeBtn = styled.button`
    width: 120px;
    height: 40px;
    background: #1C58FD;
    border-radius: 6px;
    margin-left:5px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    &:active {
        background: #347DFF;
        color: #FFFFFF; 
    }
`
const CodeTes = styled.div`
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FF4D4F;
    height: 17px;
    line-height: 17px;
    margin-top:8px;
`